import * as React from 'react'
import LiveBadge from './LiveBadge'
import TextLiveStatus from './TextLiveStatus'
import TimeInfo from './TimeInfo'
import { StorefrontItemLive } from 'DVWebNodeUtils';
import * as styles from './LiveStatus.module.scss'

interface LiveStatusProps extends StorefrontItemLive {
  isStandalone?: boolean
}

const LiveStatusContents = ({ label, status, isStandalone, timeBadge }: LiveStatusProps) => {
  if (!status || !label) {
    return timeBadge && isStandalone
      ? <TimeInfo label={timeBadge} /> : null
  }
  if (status === 'LIVE') {
    return (
      <><LiveBadge label={label} status={status} isStandalone={isStandalone} />
        {isStandalone && (<TimeInfo label={timeBadge} />)}
      </>
    )
  }
  return (
    <>
      <TextLiveStatus label={label} />
      {isStandalone && (<TimeInfo label={timeBadge} />)}
    </>
  )
}


const LiveStatus = (props: LiveStatusProps) => {
  return <div className={styles.LiveStatusContainer}><LiveStatusContents {...props} /></div>
}

export default LiveStatus
